import React from 'react';
import Topbar from '../components/Topbar';
import Navbar from "../components/Navbar";
import FootBar from '../components/FootBar';

const ChairmanProfile = () => {
  return (
    <div className="bg-gray-100 min-h-screen">
      <Topbar/>
      <Navbar/>
      <div className="w-11/12 mx-auto my-4 max-w-full rounded-lg bg-white shadow-lg overflow-hidden">
        <div className="bg-yellow-500 font-medium text-white text-center py-6">
          <h1 className="text-2xl md:text-3xl font-bold uppercase">
            Chairman of Glory and Praise Prime Academy Foundation
          </h1>
          <h2 className="text-xl md:text-2xl mt-2">Amb. Dr. Michael Bamidele Oladeji</h2>
          <p className="italic mt-1 text-sm">PhD, FCAI, FNAPPS, NIHIA</p>
        </div>
        
        <div className="p-8">
          <section className="mb-6">
            <h3 className="text-2xl font-semibold text-yellow-500 mb-4">Profile Summary</h3>
            <p className="text-gray-700 leading-relaxed">
              Born on 15th August 1952, Amb. Dr. Michael Bamidele Oladeji is a distinguished figure from Oyo State, renowned for his exemplary leadership at the Glory and Praise Prime Academy Foundation (GPPAF) in Abuja. With a blend of administrative prowess, entrepreneurial acumen, and spiritual leadership, he has significantly contributed to Nigeria's educational sector.
            </p>
          </section>

          <section className="mb-6">
            <h3 className="text-2xl font-semibold text-yellow-500 mb-4">Educational Background</h3>
            <p className="text-gray-700 leading-relaxed">
              Dr. Oladeji's academic journey includes studies at St. Luke’s Primary School, Oke-Ibadan High School, and the Institute of Purchasing and Supply, London. He earned his doctorate degrees in Ministry and Educational Management from institutions in Nigeria and Israel.
            </p>
          </section>

          <section className="mb-6">
            <h3 className="text-2xl font-semibold text-yellow-500 mb-4">Awards and Achievements</h3>
            <ul className="list-disc list-inside text-gray-700 leading-relaxed">
              <li>Ambassadorial Award for Youth Development (2014)</li>
              <li>School Administrator of the Year (2015)</li>
              <li>Excellence Leadership Award by King's Life (2016)</li>
              <li>Role Model Award by Greenland News Magazine (2017)</li>
              <li>Patron of Society for Cancer Eradication in Nigeria (2018)</li>
              <li>National Patron/Member Advisory Council Award (2021)</li>
            </ul>
          </section>

          <section className="mb-6">
            <h3 className="text-2xl font-semibold text-yellow-500 mb-4">Professional Experience</h3>
            <p className="text-gray-700 leading-relaxed">
              With over 20 years of meritorious service in various federal ministries and significant contributions to private education, Amb. Dr. Oladeji's experience spans public service, education, and Christian ministry. He retired from the Ministry of Foreign Affairs and currently serves as the Chairman of NAPPS, Kuje-Abuja.
            </p>
          </section>

          <section className="mb-6">
            <h3 className="text-2xl font-semibold text-yellow-500 mb-4">Personal Life</h3>
            <p className="text-gray-700 leading-relaxed">
              A dedicated family man, he is married to Mrs. Temilola Funke Oladeji, with children and grandchildren. His hobbies include reading, preaching, and walking.
            </p>
          </section>
        </div>
      </div>
        
      <FootBar />

    </div>
  );
};

export default ChairmanProfile;
